module.exports = __webpack_public_path__ + "static/media/logo_white.9359a8b4.png";